import ICalendarHelpApp from "ICalendarFeed/help/app";
import {
  type RouteObject,
} from "react-router";

declare let viewModel: any;

export const iCalRoute: RouteObject = {
  path: "ical",
  children: [{
    path: ":guid/help",
    loader: () => viewModel,
    Component: ICalendarHelpApp,
  }]
};